import React from 'react';
import { defineMessages, useIntl } from 'react-intl';

import classNames from 'classnames';

import { StaticImage } from '@nxte-nl/static-image';

import { VersionDependentImageWithOptionalLinkAndWidth } from '../../types/VersionDependent';
import { LocalizedLink } from '../LocalizedLink/LocalizedLink';
import styles from './Trustmarks.module.css';

const messages = defineMessages({
  trustmarkImageAlt: {
    id: 'src.components.Trustmarks.trustmarkImageAlt',
    defaultMessage: 'Trustmark',
  },
});

export type Props = {
  className?: string;
  trustMarks: VersionDependentImageWithOptionalLinkAndWidth[];
};

export const Trustmarks = React.memo((props: Props) => {
  const {
    trustMarks,
    className,
  } = props;
  const intl = useIntl();

  return (
    <div className={classNames(styles.trustmarksInnerWrapper, className)}>
      {trustMarks.map(img => img && (
        img.link
          ? <LocalizedLink
            key={intl.formatMessage(messages.trustmarkImageAlt)}
            to={img.link}
            className={styles.trustmark}
          >
            <StaticImage
              src={img.src}
              alt={intl.formatMessage(messages.trustmarkImageAlt)}
              width={img.width}
            />
          </LocalizedLink>

          : <StaticImage
            key={intl.formatMessage(messages.trustmarkImageAlt)}
            src={img.src}
            alt={intl.formatMessage(messages.trustmarkImageAlt)}
            className={styles.trustmark}
            width={img.width}
          />
      ))}
    </div>
  );
});

Trustmarks.displayName = 'Trustmarks';
